var React = require('react');
var css = require('./table.scss');
/**
 * <TableFixedHead data={this.state.table} initHeight={200}/>
 * table: {
    struct: [
        { title: '手机号码', key: function(d) {
            return <a>{d.phone}</a>;
        }, width: 200 },            // 一定要给宽度，否则不对齐
        { title: '备注', key: 'remark', width: 200 },
        { title: '更新时间', key: 'time' }
    ],
    data: [
        { phone: '13111111111', remark: '123', time: '2018-01-01' },
        { phone: '13122222222', remark: '456', time: '2018-02-02' },
        { phone: '13133333333', remark: '789', time: '2018-03-03' },
        { phone: '13144444444', remark: '000', time: '2018-04-04' }
    ],
    stripe: true
 *
 * 注：列的宽度和不能大于表格的宽度，最后一列可以不设置宽度
 */

var TableFixedHeadBase = React.createClass({

    getInitialState: function() {
        return { addGutter: false,tableBodyHeight:0, };
    },

    componentDidMount: function() {
        var tableBodyHeight = $('#scrollbody').height();
        this.setState({ tableBodyHeight: tableBodyHeight });
    },
    componentDidUpdate: function(prevProps, prevState) {
        var _this = this;
        const height = $('#scrollbody').height();
        if (height !== prevState.tableBodyHeight) {
            if( _this.props.initHeight && _this.state.tableBodyHeight>_this.props.initHeight){
                _this.setState({addGutter:true},()=>{
                    var scrollbarWidth = '17px'
                    var th = $('#gutter-th').css({
                        width: scrollbarWidth,
                        height:'1px',
                        position:'absolute',
                        right:0,
                        bottom:0,
                        background:'#bfbfbf'
                    });
                })
            }else{
                this.setState({addGutter:false});
            }
            this.setState({ tableBodyHeight: height });
        }
    },
    render: function() {
        var cls = ['fp-table-fixed-head'];
        var data = this.props.data;
        var rowStyle = this.props.rowStyle;
        var style = {};
        var colGroups = [];
        var delTd = []; //删除的单元格
        data.struct.map((o, i) => {
            colGroups.push(<col width = {o.width || this.props.minWidth}></col>);
        });

        //是否展示滚动条
        var colGroupsBody = [];
        if(this.props.initHeight){
            data.struct.map((o, i) => {
                if(i < (data.struct.length)){
                    colGroupsBody.push(<col width = {o.width || this.props.minWidth}></col>);
                } else {
                    var widthNum = o.width || this.props.minWidth;
                    widthNum = (widthNum - 12);
                    colGroupsBody.push(<col width = {widthNum}></col>);
                }
            });
            // colGroups.push(<col width = {12}></col>);
        }

        return <div className={cls.join(' ')}  style={this.props.style || {}}>
        <div className="fp-table-fixedscroll" id={'gutter-head'} style={{'position':'relative','border-top':'1px solid #bfbfbf','background': '#E4EDFF','padding-right':this.state.addGutter?'17px':'0px'}}>
                <table className='fp-table fp-head-table' style={{'border-top':'none'}}>
                    <colgroup>{colGroups}</colgroup>
                    <thead>
                        <tr style={rowStyle && rowStyle[0] ? rowStyle[0] : {}}>
                            {
                                data.struct.map((o, i) => {
                                    return <th className={o.headName || o.className || ''} >
                                        {
                                            typeof o.title === 'function' ? o.title.call(this, o, i) : o.title
                                        }
                                    </th>;
                                })
                            }
                        </tr>
                    </thead>
                </table>
                {this.state.addGutter && <div id={'gutter-th'} className="gutter"></div>}
            </div>
            <div className="fp-table-content-wrap" style={{
                'max-height': this.props.initHeight,
                'overflow-y': this.props.initHeight ? 'auto' : 'visible',
                'display': 'inline-block',
                'overflow-x': 'hidden'
            }}>
                <table className='fp-table fp-table-fixed-head-body' id={'scrollbody'}>
                    <colgroup>{colGroupsBody}</colgroup>
                    <tbody>
                        {
                            data != null && data.data!=null && data.data.length ? data.data.map(function(o, i) {
                                var cls = [];
                                if (this.props.data.stripe && i % 2) {
                                    cls.push('fp-stripe');
                                }
                                if (i == data.data.length - 1) {
                                    cls.push('fp-table-last-tr');
                                }

                                return <tr className={cls.join(' ')} data-index={ i }
                                    style={rowStyle && rowStyle[i + 1] ? rowStyle[i + 1] : {}}>
                                    {
                                        data.struct.map(function(p, index) {
                                            if(data.mergeCells){
                                                //单元格 数据处理
                                                //判断单元格  ind  =（行数 : (i *列数：data.struct.length）+ (index+1)
                                                //从合并单元格数组，根据当前单元格比较，是否需要合并。处理合并的单元格
                                                //再处理删除的单元格
                                                var ind = (i*data.struct.length) + (index+1);

                                                var ifMerge = false;
                                                var mergeRowSpan = 1;
                                                var mergeColSpan = 1;
                                                data.mergeCells.map(function(td, tdInd){
                                                    var tdIndex = td.tdIndex;
                                                    if(tdIndex == ind){
                                                        var rowspan =  td.row;
                                                        var colspan =  td.col;

                                                        //删除的单元格
                                                        if(rowspan > 0){
                                                            for(var i=1; i < rowspan;i++){
                                                                var delNum = i*data.struct.length + tdIndex;
                                                                delTd.push(delNum);
                                                                if(colspan > 0){
                                                                    for(var j=1; j < colspan;j++){
                                                                        var delNumCol = delNum + j;
                                                                        delTd.push(delNumCol);
                                                                    }
                                                                }
                                                            }
                                                            mergeRowSpan = rowspan;
                                                        }
                                                        //删除的单元格
                                                        if(colspan > 0){
                                                            for(var i=1; i < colspan;i++){
                                                                var delNum = tdIndex + i;
                                                                delTd.push(delNum);
                                                            }
                                                            mergeColSpan = colspan;
                                                        }
                                                        ifMerge = true;
                                                    }
                                                });

                                                //是否合并
                                                if(ifMerge){
                                                    return <td style={{'border-left':'1px solid #bfbfbf','border-bottom':'1px solid #bfbfbf'}} className={p.className || ''} rowSpan={mergeRowSpan} colSpan={mergeColSpan}>
                                                        {typeof p.key == 'function' ? p.key.call(this, o, i, index, p) : o[p.key]}
                                                    </td>;
                                                }

                                                //删除
                                                var ifDel = true;
                                                delTd.map(function (del,i) {
                                                    if(ind == del){
                                                        ifDel = false;
                                                    }
                                                });
                                                if(ifDel){
                                                    return <td style={{'border-left':'1px solid #bfbfbf','border-bottom':'1px solid #bfbfbf'}} className={p.className || ''}>
                                                        {typeof p.key == 'function' ? p.key.call(this, o, i, index, p) : o[p.key]}
                                                    </td>;
                                                }
                                            } else {
                                                return <td className={p.className || ''}>
                                                    {typeof p.key == 'function' ? p.key.call(this, o, i, index, p) : o[p.key]}
                                                </td>;
                                            }
                                        }.bind(this))
                                    }
                                </tr>;
                            }.bind(this))
                                : <tr>
                                    <td colSpan={data.struct.length} style={{
                                        width: '100%',
                                        "border-bottom": 0
                                    }}>
                                        {
                                            this.props.isFixedLeft || this.props.isFixedRight
                                                ? '-'
                                                : this.props.emptyText || '未查询到数据'
                                        }

                                    </td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>;
    }
});

module.exports = TableFixedHeadBase;



// WEBPACK FOOTER //
// ./component/table/tableFixedHeadBase.js